module.exports = __webpack_public_path__ + "img/image-logo-02.87cbf9d8.png";